import Drawer from "@mui/material/Drawer";
import { APP_DROPDOWN_Z_INDEX } from "../../../../utils/modalLayer";

const ResponsiveConfigContainer = ({
  isSmallScreen,
  open,
  onClose,
  children,
}) => {
  if (isSmallScreen) {
    return (
      <Drawer
        open={open}
        onClose={onClose}
        variant="temporary"
        anchor="left"
        ModalProps={{
          keepMounted: true,
          disablePortal: true,
        }}
        PaperProps={{
          sx: {
            width: 350,
            maxWidth: "90vw",
            height: "100%",
            zIndex: APP_DROPDOWN_Z_INDEX,
          },
        }}
      >
        {children}
      </Drawer>
    );
  }

  return children;
};

export default ResponsiveConfigContainer;
